import React, { useState } from "react";
import { View, Text, Image } from "react-native";
import { useChat } from "../../context/ChatContext";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { TouchableOpacity } from "react-native-gesture-handler";
import { AppImages } from "../../utility/AppImages";
import AddMemberContactModal from "../../screens/Auth/WebScreens/ChatScreen/AddMemberModal";
import Avatar from "../choose-avatar-components/Avatar";

const ChatHeader = ({ selectionMode, handleCancelSelection }) => {
  const { currentChat, userData, userStatuses } = useChat();
  const [isModalVisible, setModalVisible] = useState(false);
  const otherMembers = currentChat?.members?.filter(
    (member) => member !== userData?.username
  );

  const memberNames = otherMembers?.join(", ") || "Chat";

  const getStatusText = () => {
    if (!currentChat || !currentChat.conversationId) return "offline";

    if (otherMembers?.length > 1) {
      return otherMembers
        .map(
          (member) =>
            `${member}: ${
              userStatuses[currentChat.conversationId]?.[member] || "offline"
            }`
        )
        .join(", ");
    } else if (otherMembers?.length === 1) {
      const singleMember = otherMembers[0];
      return (
        userStatuses[currentChat.conversationId]?.[singleMember] || "offline"
      );
    }
    return "offline";
  };

  return (
    <View
      style={{
        flexDirection: "row",
        padding: 10,
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <View style={{ flexDirection: "row", width: "70%" }}>
        <View
          style={{
            backgroundColor: AppColors.appViolentColor_6D08C3,
            borderRadius: 100,
            alignSelf: "center",
          }}
        >
          <Avatar variant="chatAvatar" src={currentChat?.profilePicture} />
        </View>

        <View style={{ marginLeft: 10, flex: 1 }}>
          <Text
            style={[AppFontStyle.BOLD_ANYBODY_16, { flexShrink: 1 }]}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {memberNames}
          </Text>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                color: getStatusText().includes("online")
                  ? AppColors.green_3D985E
                  : AppColors.white_B7C0CD,
                marginTop: 8,
              },
            ]}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {getStatusText()}
          </Text>
        </View>
      </View>
      {selectionMode && (
        <TouchableOpacity onPress={handleCancelSelection}>
          <Text style={AppFontStyle.REGULAR_ANYBODY_16}>Cancel</Text>
        </TouchableOpacity>
      )}
      {!selectionMode && currentChat.type === "group" && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            source={AppImages.icPin}
            style={{
              width: 40,
              height: 25,
              borderRadius: 20,
              resizeMode: "contain",
            }}
          />
          <TouchableOpacity
            onPress={() => setModalVisible(true)}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 5,
              cursor: "pointer",
            }}
          >
            <View
              style={{
                height: 24,
                width: 24,
                borderRadius: 100,
                backgroundColor: AppColors.appGreenColor_51AF07,
              }}
            >
              <Image
                source={AppImages.icPlus}
                style={{ tintColor: "black", height: 24, width: 24 }}
                resizeMode="contain"
              />
            </View>

            <Text style={[AppFontStyle.BOLD_ANYBODY_14, {}]}>Add Members</Text>
          </TouchableOpacity>
        </View>
      )}
      <AddMemberContactModal
        isVisible={isModalVisible}
        onClose={() => setModalVisible(false)}
        otherMembers={otherMembers}
      />
    </View>
  );
};

export default ChatHeader;
